import { useAppState } from 'Context/AppContext/AppContext'

const showFunderGoalsPage = 'showFunderGoalsPage'
const showRecurringTasks = 'showRecurringTasks'
const showPrioritiesStats = 'showPrioritiesStats'
const showFunderImpactNarrativesUpdates = 'showFunderImpactNarrativesUpdates'
const showImpactDashboardFilters = 'showImpactDashboardFilters'
const showNewGoalsList = 'showNewGoalsList'
const show2025GoalsWizard = 'show2025GoalsWizard'
const useHubspotEvents = 'useHubspotEvents'
const showNewIntakeFlow = 'showNewIntakeFlow'
const showNewCoachingHub = 'showNewCoachingHub'

const useAwsFlagActive = (
  featureFlagName: string,
  orgFeatureFlags?: string[]
) => {
  const { awsFeatureFlags } = useAppState()
  const { activeFeatureFlags } = awsFeatureFlags
  let canOrgSeeFeature = true

  if (orgFeatureFlags) {
    canOrgSeeFeature = Boolean(
      orgFeatureFlags.find((name) => name === featureFlagName)
    )
  }

  if (!canOrgSeeFeature) {
    return canOrgSeeFeature
  }

  return Boolean(activeFeatureFlags.includes(featureFlagName))
}

export {
  useAwsFlagActive,
  showFunderGoalsPage,
  showRecurringTasks,
  showPrioritiesStats,
  showFunderImpactNarrativesUpdates,
  showImpactDashboardFilters,
  showNewGoalsList,
  show2025GoalsWizard,
  useHubspotEvents,
  showNewIntakeFlow,
  showNewCoachingHub,
}
